const API_BASE_PATH = '/dashboard'

const DASHBOARD = {
  LIST: `${API_BASE_PATH}/list`
}

export default DASHBOARD
